import { useRouteMatch } from "react-router-dom";

export const useRouteUserId = () => {
	const match = useRouteMatch<{ userId: string }>();
	const routeUserId = Number(match.params.userId);

	return { routeUserId };
};
